(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grand-hotel-order-request"]) return;
  try {
    
(() => {
 const init = root => {
  const form = root.querySelector('.gh-request__form');
  const review = root.querySelector('[data-gh-request-review]');
  if (!form || !review || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const inputs = [...form.querySelectorAll('[data-gh-request-quantity]')];
  const po = form.querySelector('[data-gh-request-po]');
  const notes = form.querySelector('[data-gh-request-notes]');
  const body = form.querySelector('[data-gh-request-body]');
  const status = form.querySelector('[data-gh-request-status]');
  const panel = form.querySelector('[data-gh-request-confirm]');
  const send = form.querySelector('[data-gh-request-send]');
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100) + ' USD';
  let reviewed = '';
  const read = () => {
   let total = 0;
   const items = [];
   for (const input of inputs) {
    const quantity = input.value.trim() === '' ? 0 : Number(input.value);
    const cents = Number(input.dataset.cents);
    if (!Number.isSafeInteger(quantity) || quantity < 0 || !Number.isSafeInteger(cents * quantity) || !input.checkValidity()) throw new Error(root.dataset.invalidMessage);
    if (quantity > 0) { items.push({title:input.dataset.title,quantity,cents}); total += cents * quantity; }
   }
   if (!Number.isSafeInteger(total)) throw new Error(root.dataset.invalidMessage);
   return {items,total,po:po.value.trim(),notes:notes.value.trim()};
  };
  const clear = () => { reviewed = ''; panel.hidden = true; send.disabled = true; body.value = ''; };
  form.addEventListener('input', () => {
   clear(); status.textContent = '';
   try { form.querySelector('[data-gh-request-total]').textContent = money(read().total); } catch (error) { status.textContent = error.message; }
  });
  review.addEventListener('click', () => {
   clear();
   try {
    const data = read();
    if (!data.items.length) throw new Error(root.dataset.emptyMessage);
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const lines = data.items.map(item => item.quantity + ' × ' + item.title + ' — ' + money(item.cents) + ' / ' + money(item.cents * item.quantity));
    const list = form.querySelector('[data-gh-request-lines]'); list.replaceChildren();
    for (const text of lines) { const li = document.createElement('li'); li.textContent = text; list.append(li); }
    const parts = [body.dataset.title, ...lines, body.dataset.subtotalLabel + ': ' + money(data.total), body.dataset.delivery, body.dataset.terms, body.dataset.pending];
    if (data.po) parts.push(body.dataset.poLabel + ': ' + data.po);
    if (data.notes) parts.push(body.dataset.notesLabel + ': ' + data.notes);
    body.value = parts.join('\n'); reviewed = JSON.stringify(data); status.textContent = ''; panel.hidden = false; send.disabled = false; panel.querySelector('h2').focus();
   } catch (error) { status.textContent = error.message; status.focus(); }
  });
  form.querySelector('[data-gh-request-edit]').addEventListener('click', () => { clear(); inputs[0]?.focus(); });
  form.addEventListener('submit', event => {
   try {
    if (!reviewed || reviewed !== JSON.stringify(read()) || !form.checkValidity()) throw new Error(root.dataset.changedMessage);
    status.textContent = root.dataset.sendingMessage;
   } catch (error) { event.preventDefault(); clear(); status.textContent = error.message; status.focus(); }
  });
  review.disabled = false;
 };
 document.querySelectorAll('[data-gh-request]').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gh-request]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grand-hotel-ordering"]) return;
  try {
    
  function initializeGrandHotelOrdering(root = document) {
    root.querySelectorAll('[data-gh-order-form]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const inputs = [...form.querySelectorAll('[data-gh-quantity]')];
      const button = form.querySelector('[data-gh-submit]');
      const status = form.querySelector('[data-gh-status]');
      const total = form.querySelector('[data-gh-subtotal]');
      const currency = window.Shopify?.currency?.active || 'USD';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency});
      let ready = false;
      const updateTotal = () => {
        const cents = inputs.reduce((sum,input) => sum + (Number(input.value) || 0) * Number(input.dataset.unitPrice), 0);
        total.textContent = formatter.format(cents / 100);
      };
      const showError = (message) => { status.textContent = message; status.focus(); };
      const readCart = async () => {
        const response = await fetch(form.dataset.cartUrl + '.js', {credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error(form.dataset.errorMessage);
        return response.json();
      };
      form.addEventListener('input', updateTotal);
      readCart().then((cart) => {
        inputs.forEach((input) => {
          input.value = String(cart.items.filter((item) => String(item.variant_id) === input.dataset.variantId).reduce((sum,item) => sum + item.quantity,0));
        });
        updateTotal();
        ready = true;
        button.disabled = inputs.length === 0;
      }).catch(() => showError(form.dataset.errorMessage));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!ready || button.disabled) return;
        if (!form.reportValidity()) return;
        let positive = false;
        const updates = {};
        for (const input of inputs) {
          const quantity = Number(input.value);
          const minimum = Number(input.dataset.ruleMin || 1);
          const increment = Number(input.step || 1);
          if (!Number.isSafeInteger(quantity) || quantity < 0 || (quantity > 0 && (quantity < minimum || quantity % increment !== 0))) {
            showError(form.dataset.quantityMessage); input.focus(); return;
          }
          if (quantity > 0) positive = true;
          updates[input.dataset.variantId] = quantity;
        }
        if (!positive) { showError(form.dataset.emptyMessage); return; }
        button.disabled = true;
        form.setAttribute('aria-busy','true');
        status.textContent = form.dataset.busyMessage;
        try {
          const cart = await readCart();
          if (cart.items.some((item) => !Object.hasOwn(updates,String(item.variant_id)))) throw new Error(form.dataset.mixedMessage);
          const response = await fetch(form.dataset.updateUrl, {
            method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({updates,attributes:{...cart.attributes,'Purchase order number':form.querySelector('[data-gh-po]').value.trim()},note:form.querySelector('[data-gh-notes]').value.trim()})
          });
          if (!response.ok) throw new Error(form.dataset.errorMessage);
          const saved = await response.json();
          if (Object.entries(updates).some(([id,quantity]) => saved.items.filter((item) => String(item.variant_id) === id).reduce((sum,item) => sum + item.quantity,0) !== quantity)) throw new Error(form.dataset.errorMessage);
          status.textContent = form.dataset.readyMessage;
          window.location.assign(form.dataset.cartUrl);
        } catch (error) { showError(error.message || form.dataset.errorMessage); button.disabled = false; form.removeAttribute('aria-busy'); }
      });
    });
  }
  initializeGrandHotelOrdering();
  document.addEventListener('shopify:section:load', (event) => initializeGrandHotelOrdering(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-collection-film"] && !Shopify.designMode) return;
  try {
    

function initializeMonetCollectionFilms() {
  document.querySelectorAll('[data-monet-collection-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetCollectionFilms, {once:true});
} else {
  initializeMonetCollectionFilms();
}
document.addEventListener('shopify:section:load', initializeMonetCollectionFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-la-mer-film"] && !Shopify.designMode) return;
  try {
    
function initializeMonetLaMerFilms() {
  document.querySelectorAll('[data-monet-la-mer-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetLaMerFilms, {once:true});
} else {
  initializeMonetLaMerFilms();
}
document.addEventListener('shopify:section:load', initializeMonetLaMerFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-signature-film"] && !Shopify.designMode) return;
  try {
    
function initializeMonetSignatureFilms() {
  document.querySelectorAll('[data-monet-signature-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetSignatureFilms, {once:true});
} else {
  initializeMonetSignatureFilms();
}
document.addEventListener('shopify:section:load', initializeMonetSignatureFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-signature-gallery"] && !Shopify.designMode) return;
  try {
    
function initializeMonetSignatureGalleries() {
  document.querySelectorAll('[data-monet-signature-gallery]').forEach((root) => {
    if (root.dataset.galleryInitialized) return;
    root.dataset.galleryInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const grid = root.querySelector('[data-gallery-grid]');
    const cards = Array.from(root.querySelectorAll('[data-gallery-card]'));
    const controls = root.querySelector('[data-gallery-controls]');
    const previous = controls.querySelector('[data-gallery-previous]');
    const next = controls.querySelector('[data-gallery-next]');
    const progress = controls.querySelector('[data-gallery-progress]');
    let current = 0;
    let queued = false;
    const updateNavigation = () => {
      controls.hidden = !portrait.matches || cards.length < 2;
      if (cards.length) {
        const firstOffset = cards[0].offsetLeft;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const candidate = Math.abs(card.offsetLeft - firstOffset - grid.scrollLeft);
          if (candidate < distance) { distance = candidate; current = index; }
        });
      }
      previous.disabled = current === 0;
      next.disabled = current === cards.length - 1;
      progress.textContent = progress.dataset.counterTemplate.replace('__CURRENT__', String(current + 1));
    };
    const goToCard = (index) => {
      if (!cards[index]) return;
      grid.scrollTo({left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => goToCard(current - 1));
    next.addEventListener('click', () => goToCard(current + 1));
    grid.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { updateNavigation(); queued = false; });
    }, {passive:true});
    portrait.addEventListener('change', updateNavigation);
    cards.forEach((card) => {
      const video = card.querySelector('video');
      const button = card.querySelector('.monet-signature-gallery__toggle');
      if (!video || !button) return;
      let visible = false;
      let pausedByUser = false;
      let allowMotion = !reducedMotion.matches;
      const updateButton = () => {
        const playing = !video.paused;
        button.dataset.playing = String(playing);
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      };
      const syncPlayback = () => {
        if (visible && !document.hidden && !pausedByUser && allowMotion) video.play().catch(updateButton);
        else video.pause();
      };
      const selectSource = () => {
        const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        if (video.getAttribute('src') === src) return;
        video.poster = poster;
        video.src = src;
        video.muted = true;
        video.load();
        syncPlayback();
      };
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('loadedmetadata', syncPlayback);
      button.addEventListener('click', () => {
        if (video.paused) { pausedByUser = false; allowMotion = true; video.play().catch(updateButton); }
        else { pausedByUser = true; video.pause(); }
      });
      portrait.addEventListener('change', selectSource);
      reducedMotion.addEventListener('change', () => { allowMotion = !reducedMotion.matches; syncPlayback(); });
      document.addEventListener('visibilitychange', syncPlayback);
      const observer = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .4;
        syncPlayback();
      }, {threshold:[0,.4,1]});
      observer.observe(video);
      selectSource();
      button.hidden = false;
      updateButton();
    });
    updateNavigation();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMonetSignatureGalleries, {once:true});
else initializeMonetSignatureGalleries();
document.addEventListener('shopify:section:load', initializeMonetSignatureGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-access"]) return;
  try {
    
  document.querySelectorAll('[data-partner-destination]').forEach((root) => {
    const destination = root.dataset.partnerDestination;
    if (!window.Shopify?.designMode && destination?.startsWith('/') && !destination.startsWith('//')) window.location.replace(destination);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retail-partner-order-request"]) return;
  try {
    
  function initializeRetailOrdering() {
    document.querySelectorAll('[data-retail-order]').forEach((root) => {
      if (root.dataset.initialized) return;
      const catalogElement = root.querySelector('[data-retail-catalog]');
      const form = root.querySelector('form');
      if (!catalogElement || !form) return;
      root.dataset.initialized = 'true';
      const catalog = JSON.parse(catalogElement.textContent);
      const money = (cents) => new Intl.NumberFormat('en-US', {style:'currency',currency:root.dataset.currency}).format(cents / 100) + ' ' + root.dataset.currency;
      const grid = root.querySelector('[data-retail-grid]');
      const rows = [];
      const cards = [];
      const review = root.querySelector('[data-retail-review]');
      const send = root.querySelector('[data-retail-send]');
      const confirmation = root.querySelector('[data-retail-confirm]');
      const status = root.querySelector('[data-retail-status]');
      const body = root.querySelector('[data-retail-body]');
      const po = root.querySelector('[data-retail-po]');
      const notes = root.querySelector('[data-retail-notes]');
      const minimum = Number(root.dataset.minimum);
      let reviewed = '';
      catalog.forEach((product, index) => {
        const article = document.createElement('article');
        article.className = 'retail-order__card';
        const imageWrap = document.createElement('div');
        imageWrap.className = 'retail-order__image';
        const image = document.createElement('img');
        const imageUrl = new URL(product.image);
        imageUrl.searchParams.set('width','800');
        image.src = imageUrl.toString();
        image.srcset = [320,480,640,800].map(width => {const url=new URL(product.image);url.searchParams.set('width',String(width));return url.toString()+' '+width+'w';}).join(', ');
        image.sizes = '(min-width: 990px) 380px, (min-width: 640px) 45vw, 90vw';
        if(index===0)image.fetchPriority='high';
        image.alt = product.title;
        image.width = 600;
        image.height = 600;
        image.loading = index < 3 ? 'eager' : 'lazy';
        imageWrap.append(image);
        const title = document.createElement('h2');
        title.textContent = product.title;
        article.append(imageWrap,title);
        product.variants.forEach((variant) => {
          const row = document.createElement('div');
          row.className = 'retail-order__row';
          const id = form.id + '-' + variant.id;
          const label = document.createElement('label');
          label.htmlFor = id;
          label.append(document.createTextNode(variant.title));
          const price = document.createElement('span');
          price.textContent = money(variant.cents) + ' ' + root.dataset.perUnit;
          label.append(price);
          const input = document.createElement('input');
          input.type = 'number';input.min = '0';input.step = '1';input.value = '0';input.inputMode = 'numeric';input.id = id;
          input.dataset.retailQuantity = variant.id;
          const name = variant.title === product.title ? product.title : product.title + ' — ' + variant.title;
          input.setAttribute('aria-label',root.dataset.quantity + ': ' + name);
          rows.push({input,name,variant});
          row.append(label,input);article.append(row);
        });
        grid.append(article);
        cards.push({article,text:(product.title+' '+product.variants.map(v=>v.title).join(' ')).toLocaleLowerCase()});
      });
      const selection = () => {
        let merchandise = 0,equipment = 0,total = 0;
        const items = [];
        rows.forEach(({input,name,variant}) => {
          const quantity = Number(input.value);
          if (!Number.isSafeInteger(quantity) || quantity < 0 || !Number.isSafeInteger(quantity * variant.cents)) throw new Error(root.dataset.invalid);
          if (!quantity) return;
          if (variant.kind === 'aromabot' && quantity < variant.minimum) throw new Error(root.dataset.machineError);
          const amount = quantity * variant.cents;
          total += amount;
          if (!Number.isSafeInteger(total)) throw new Error(root.dataset.invalid);
          if (variant.kind === 'merchandise') merchandise += amount;else equipment += amount;
          items.push({id:variant.id,name,quantity,cents:variant.cents,amount});
        });
        return {items,merchandise,equipment,total};
      };
      const validate = () => {
        const value = selection();
        if (!value.items.length) throw new Error(root.dataset.empty);
        if (value.merchandise > 0 && value.merchandise < minimum) throw new Error(root.dataset.minimumError + ' ' + money(minimum));
        return value;
      };
      const signature = (value) => JSON.stringify([value.items.map(i=>[i.id,i.quantity]),po.value.trim(),notes.value.trim()]);
      const reset = (message = '') => {reviewed='';confirmation.hidden=true;send.disabled=true;body.value='';status.textContent=message;};
      const update = () => {
        try {
          const value = selection();
          root.querySelector('[data-retail-merchandise]').textContent = money(value.merchandise);
          root.querySelector('[data-retail-equipment]').textContent = money(value.equipment);
          root.querySelector('[data-retail-total]').textContent = money(value.total);
        } catch (error) {status.textContent=error.message;}
      };
      form.addEventListener('input',(event) => {
        if (event.target.matches('[data-retail-search]')) return;
        const message = reviewed ? root.dataset.changed : '';
        reset(message);update();
      });
      root.querySelector('[data-retail-search]').addEventListener('input',(event) => {
        const query = event.target.value.trim().toLocaleLowerCase();
        let visible = 0;
        cards.forEach(({article,text}) => {article.hidden=!text.includes(query);if(!article.hidden)visible++;});
        root.querySelector('[data-retail-no-results]').hidden = visible !== 0;
      });
      review.addEventListener('click',() => {
        try {
          const value = validate();
          const lines = root.querySelector('[data-retail-lines]');
          lines.replaceChildren();
          const itemLines = value.items.map((item) => item.quantity + ' × ' + item.name + ' — ' + money(item.cents) + ' / ' + money(item.amount));
          itemLines.forEach((text) => {const li=document.createElement('li');li.textContent=text;lines.append(li);});
          const details = [root.dataset.bodyTitle,root.dataset.businessLabel+': '+root.dataset.business,root.dataset.locationLabel+': '+root.dataset.location,root.dataset.orderType,...itemLines,root.dataset.merchandiseLabel+': '+money(value.merchandise),root.dataset.equipmentLabel+': '+money(value.equipment),root.dataset.totalLabel+': '+money(value.total)];
          if(po.value.trim())details.push(root.dataset.poLabel+': '+po.value.trim());
          if(notes.value.trim())details.push(root.dataset.notesLabel+': '+notes.value.trim());
          details.push(root.dataset.shipping,root.dataset.payment,root.dataset.pending);
          body.value=details.join('\n');reviewed=signature(value);confirmation.hidden=false;send.disabled=false;status.textContent='';confirmation.querySelector('h2').focus();
        } catch(error) {reset(error.message);status.focus();}
      });
      root.querySelector('[data-retail-edit]').addEventListener('click',() => {reset(root.dataset.changed);review.focus();});
      form.addEventListener('submit',(event) => {
        try {
          const value = validate();
          if(!reviewed || signature(value)!==reviewed)throw new Error(root.dataset.changed);
          send.disabled=true;status.textContent=root.dataset.sending;
        } catch(error) {event.preventDefault();reset(error.message);status.focus();}
      });
      review.disabled=false;update();
    });
  }
  initializeRetailOrdering();
  document.addEventListener('shopify:section:load',initializeRetailOrdering);

  } catch(e) { console.error(e); }
})();
})();
